import React from "react";

export default function Frontend() {
  return (
    <li className="skills__container__cards__card skills__container__cards__item">
      <div className="skills__container__cards__card__frame">
        <h2 className="skills__container__cards__card__frame__title">
          <i className="ri-code-s-slash-line"></i>
        </h2>
      </div>
      <div className="skills__container__cards__card__overlay"></div>
      <div className="skills__container__cards__card__content">
        <h2>Frontend</h2>
        <ul>
          <li>HTML5</li>
          <li>CSS3</li>
          <li>JavaScript</li>
          <li>ReactJS</li>
          <li>Sass</li>
          <li>Strapi</li>
          <li>Bootstrap</li>
          <li>PHP</li>
        </ul>
      </div>
    </li>
  );
}
